export const getAgreementsState = state => state.agreements;